export const isInDevelopment = () =>
  process.env.NODE_ENV === 'development';

export const isInTest = () =>
  process.env.NODE_ENV === 'test';

export const isInProduction = () =>
  process.env.NODE_ENV === 'production';
